import Axios from "axios";

import { apiUrl, serializeObjToGetStr } from "../../constants";

const inventoryBaseUrl = `${apiUrl}/inventory`;
const config = {
    headers: { "Content-Type": "application/json-patch+json" }
};

export const inventoryApi = {
  getAll: (request) => {
    const query = serializeObjToGetStr(request);
    return Axios.get(`${inventoryBaseUrl}?${query}`);
  },
  new: inventory => {
    return Axios.post(inventoryBaseUrl, inventory, config);
  },
  close: request => {
    // return Axios.post(`${inventoryBaseUrl}/close/${request.id}`, {}, config);
    return Axios.get(`${inventoryBaseUrl}/close/${request.id}`, config);
  },
  isAnyOpen: () => {
    return Axios.get(`${inventoryBaseUrl}/isanyopen`, config);
  },
  allForExcel: (request) => {
    const query = serializeObjToGetStr(request);
    return Axios.get(`${inventoryBaseUrl}/allforexcel?${query}`);
  },
};



